"use es6";

import { cubicBezier } from "./cubic-bezier";
import { mirrorEasing } from "./modifiers/mirror";
import { reverseEasing } from "./modifiers/reverse";
const backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = reverseEasing(backOut);
const backInOut = mirrorEasing(backIn);
export { backIn, backInOut, backOut };